import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { getCurrentTheme, setTheme } from '../../../utils'
import { Strings } from '../../../resources'
import { GlobalContext } from '../../../context/GlobalState'
import dropDownArrow from './arrowDown.svg'
import glitchArrowDown from './glitchArrowDown.svg'
const allThemes = require('../../../config/themes.json')

const ThemeChanger = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false)
  const { setIsChaningTheme } = useContext(GlobalContext)

  const changeTheme = (themeId) => {
    setTheme(themeId)
    setIsChaningTheme(true)
    typeof window !== 'undefined' && window.location.reload()
    setTimeout(() => {
      setIsChaningTheme(false)
    }, 1500)
  }

  const toggleThemeDrawer = () => {
    setDrawerOpen(!isDrawerOpen)
  }

  const ref = useRef()

  let prevScrollpos = typeof window !== 'undefined' ? window.pageYOffset : 0

  const handleScrollChange = () => {
    if (
      ref.current &&
      typeof window !== 'undefined' &&
      typeof document !== 'undefined'
    ) {
      const maxScroll = document.body.clientHeight - window.innerHeight
      let currentScrollPos = window.pageYOffset
      const isScolledDown = maxScroll > 0 && currentScrollPos > prevScrollpos

      if (window.innerWidth > 2000) {
        if (isScolledDown) {
          document.getElementById('site-header').style.top = '0px'
          document.getElementById('site-header').style.bottom = 'auto'
        } else {
          document.getElementById('site-header').style.bottom = 'auto'
          document.getElementById('site-header').style.top = '-1000px'
        }
      } else {
        if (isScolledDown) {
          document.getElementById('site-header').style.bottom = '0px'
          document.getElementById('site-header').style.top = 'auto'
        } else {
          document.getElementById('site-header').style.bottom = '-1000px'
          document.getElementById('site-header').style.top = 'auto'
        }
      }

      prevScrollpos = currentScrollPos
    }
  }

  const handleWindowResize = () => {
    if (ref.current && typeof window !== 'undefined') {
      if (window.innerWidth > 2000) {
        document.getElementById('site-header').style.top = '0px'
        document.getElementById('site-header').style.bottom = 'auto'
      } else {
        document.getElementById('site-header').style.bottom = '0px'
        document.getElementById('site-header').style.top = 'auto'
      }
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScrollChange)
      window.addEventListener('resize', handleWindowResize)
    }

    return () => {
      window.removeEventListener('scroll', handleScrollChange)
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  const getMenuDirection = () => {
    if (typeof window !== 'undefined') {
      return window.innerHeight > 2000 ? 'bottom' : 'top'
    }
  }

  return (
    <div id="site-header" ref={ref} className="themeChanger">
      <svg
        width="434"
        height="121"
        viewBox="0 0 434 121"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0L433.333 0V38.9236C433.333 50.1671 425.923 60.0653 415.134 63.2317L223.972 119.336C219.318 120.702 214.369 120.704 209.715 119.34L18.2098 63.2261C7.41603 60.0634 0 50.1625 0 38.9149V0Z"
          fill="#df616d"
        />
      </svg>

      <div className="themeChanger__wrapper">
        <div className="themeChanger__meta">
          <h3 className="themeChanger__meta__text">
            {Strings.try_switching_themes}
          </h3>
          <h3 className="themeChanger__meta__currentTheme">
            {getCurrentTheme().name} Theme
          </h3>
        </div>
        <Menu
          className={'themeChanger__dropdownMenu'}
          menuButton={
            <MenuButton className={'themeChanger__drawer__btn'}>
              <div
                className={`themeChanger__drawer ${isDrawerOpen ? 'open' : ''}`}
                onClick={() => toggleThemeDrawer()}
              >
                <img
                  className="themeChanger__drawer__img"
                  src={
                    getCurrentTheme().name !== 'Glitch'
                      ? dropDownArrow
                      : glitchArrowDown
                  }
                  alt="drawer_arrow"
                />
              </div>
            </MenuButton>
          }
          align="center"
          position="auto"
          direction={getMenuDirection()}
        >
          {/* Other Themes -------------------------- */}
          {/* // { "id": "glitch-theme", "name": "Glitch", "type": "monolith" },
          // { "id": "gaming-theme", "name": "Gaming", "type": "monolith" },
          // { "id": "arcade-theme", "name": "Arcade", "type": "monolith" }, */}

          {allThemes.map((theme, index) => (
            <MenuItem
              key={index}
              className={`themeChanger__menuItem ${
                getCurrentTheme().name === theme.name ? 'selected' : ''
              }`}
              onClick={() => changeTheme(theme.id)}
            >
              {theme.name}

              <span className="themeChanger__menuItem__activationString">
                {Strings.activated}
              </span>
            </MenuItem>
          ))}
        </Menu>
      </div>
    </div>
  )
}

export default ThemeChanger
